module.exports = __webpack_public_path__ + "img/exmlogo.12669062.svg";